module.exports = __webpack_public_path__ + "img/user-plus-02.babe890e.svg";